const FeInvoicePayments = () => import("Modules/sales/fe_invoices/views/FeInvoicePayments");
const FeInvoicePaymentsForm = () => import("Modules/sales/fe_invoices/views/FeInvoicePaymentsForm");

export default {
    children: [
        {
            path: "sales/payments",
            name: "fe_invoice_payments",
            component: FeInvoicePayments,
            meta: {
                requiresAuth: true,
                title: "lang.fe_invoice_payments",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["invoices.read"],
            },
        },
        {
            path: "sales/payment/:id?",
            name: "fe_invoice_payment",
            component: FeInvoicePaymentsForm,
            meta: {
                requiresAuth: true,
                title: "lang.fe_invoice_payments",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["invoices.read"],
            },
        },
    ],
};
